export enum ConversationOutcomeEnum {
  Resolved = 'Resolved',
  Unresolved = 'Unresolved',
}
